export default __webpack_public_path__ + "static/media/sell-03 copy.1ff5f524.png";